module.exports = __webpack_public_path__ + "media/ad_preview/si-8bf308d3.png";